import { wrapperBuilder } from './build';
const variables = wrapperBuilder.getVariablesRegisterInstance();

variables.addVariable('isShowingName', { startValue: false });
variables.addVariable('aditionalMessage', { startValue: '' });
variables.addVariable('name', { startValue: '' });
